var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"align-center":"","justify-start":"","row":"","fill-height":""}},[_c('v-icon',{staticClass:"icon"},[_vm._v("\n        save\n    ")]),_c('h3',[_vm._v(_vm._s(_vm.labelButton))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }